import { useQuery } from "@tanstack/react-query";
import { api } from "lib/api";
import { useDashboardSettings } from "../settings/store";
import { dashboardActividadesQueryKeys as keys } from "./keys";

export function useDashboardActividades(enabled = true) {
  const s = useDashboardSettings();

  return useQuery({
    queryKey: keys.actividades(s.periodoId),
    queryFn: () => api("/dashboard/club/actividades", {}, { periodoId: s.periodoId }),
    enabled: enabled && !!s.periodoId,
    staleTime: 20_000,
  });
}

export function useDashboardActividad(actividadId, enabled = true) {
  const s = useDashboardSettings();

  return useQuery({
    queryKey: keys.actividad(s.periodoId, actividadId),
    queryFn: () => api(`/dashboard/club/actividades/${actividadId}`, {}, { periodoId: s.periodoId }),
    enabled: enabled && !!s.periodoId && !!actividadId,
    staleTime: 20_000,
  });
}

export function useDashboardActividadesMeta(enabled = true) {
  const s = useDashboardSettings();

  return useQuery({
    queryKey: keys.actividadesMeta(s.semestreId || "unknown"),
    queryFn: () => api("/dashboard/club/actividades/meta", {}, { periodoId: s.periodoId }),
    enabled: enabled && !!s.periodoId,
    staleTime: 60_000,
  });
}

export function useDashboardActividadRosters(enabled = true) {
  const s = useDashboardSettings();

  return useQuery({
    queryKey: keys.actividadesRosters(s.periodoId),
    queryFn: () => api("/dashboard/club/actividades/rosters/options", {}, { periodoId: s.periodoId }),
    enabled: enabled && !!s.periodoId,
    staleTime: 60_000,
  });
}

export function useDashboardActividadEncargos(actividadId, enabled = true) {
  const s = useDashboardSettings();

  return useQuery({
    queryKey: keys.encargos(s.periodoId, actividadId),
    queryFn: () => api(`/dashboard/club/actividades/${actividadId}/encargos`, {}, { periodoId: s.periodoId }),
    enabled: enabled && !!s.periodoId && !!actividadId,
    staleTime: 20_000,
  });
}

export function useDashboardActividadAsistenciaSocios(actividadId, enabled = true) {
  const s = useDashboardSettings();

  return useQuery({
    queryKey: keys.asistenciaSocios(s.periodoId, actividadId),
    queryFn: () => api(`/dashboard/club/actividades/${actividadId}/asistencia/socios`, {}, { periodoId: s.periodoId }),
    enabled: enabled && !!s.periodoId && !!actividadId,
    staleTime: 20_000,
  });
}

export function useDashboardActividadAsistenciaInstructores(actividadId, enabled = true) {
  const s = useDashboardSettings();

  return useQuery({
    queryKey: keys.asistenciaInstructores(s.periodoId, actividadId),
    queryFn: () => api(`/dashboard/club/actividades/${actividadId}/asistencia/instructores`, {}, { periodoId: s.periodoId }),
    enabled: enabled && !!s.periodoId && !!actividadId,
    staleTime: 20_000,
  });
}

export function useDashboardActividadRemplazos(actividadId, enabled = true) {
  const s = useDashboardSettings();

  return useQuery({
    queryKey: keys.remplazos(s.periodoId, actividadId),
    queryFn: () => api(`/dashboard/club/actividades/${actividadId}/remplazos`, {}, { periodoId: s.periodoId }),
    enabled: enabled && !!s.periodoId && !!actividadId,
    staleTime: 20_000,
  });
}

export function useDashboardActividadPreceptorias(actividadId, enabled = true) {
  const s = useDashboardSettings();

  return useQuery({
    queryKey: keys.preceptorias(s.periodoId, actividadId),
    queryFn: () => api(`/dashboard/club/actividades/${actividadId}/preceptorias`, {}, { periodoId: s.periodoId }),
    enabled: enabled && !!s.periodoId && !!actividadId,
    staleTime: 20_000,
  });
}

export function useDashboardMaterialesCatalog(enabled = true) {
  const s = useDashboardSettings();

  return useQuery({
    queryKey: keys.materialesCatalog(s.periodoId),
    queryFn: () => api("/dashboard/club/actividades/catalogs/materiales", {}, { periodoId: s.periodoId }),
    enabled: enabled && !!s.periodoId,
    staleTime: 60_000,
  });
}

export function useDashboardGastosCategoriasCatalog(enabled = true) {
  const s = useDashboardSettings();

  return useQuery({
    queryKey: keys.categoriasGastosCatalog(s.periodoId),
    queryFn: () => api("/dashboard/club/actividades/catalogs/categorias-gastos", {}, { periodoId: s.periodoId }),
    enabled: enabled && !!s.periodoId,
    staleTime: 60_000,
  });
}

export function useDashboardActividadMateriales(actividadId, enabled = true) {
  const s = useDashboardSettings();

  return useQuery({
    queryKey: keys.actividadMateriales(s.periodoId, actividadId),
    queryFn: () => api(`/dashboard/club/actividades/${actividadId}/materiales`, {}, { periodoId: s.periodoId }),
    enabled: enabled && !!s.periodoId && !!actividadId,
    staleTime: 20_000,
  });
}

export function useDashboardActividadGastos(actividadId, enabled = true) {
  const s = useDashboardSettings();

  return useQuery({
    queryKey: keys.actividadGastos(s.periodoId, actividadId),
    queryFn: () => api(`/dashboard/club/actividades/${actividadId}/gastos`, {}, { periodoId: s.periodoId }),
    enabled: enabled && !!s.periodoId && !!actividadId,
    staleTime: 20_000,
  });
}


